import { render, staticRenderFns } from "./AcceptPane.vue?vue&type=template&id=845d4230&scoped=true"
import script from "./AcceptPane.vue?vue&type=script&lang=js"
export * from "./AcceptPane.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "845d4230",
  null
  
)

export default component.exports